import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from "./FlowchartPaper_Interface"

export interface PersoneOffTime_Interface {
    id:number,
    dsc:String,
    startTime:String,
    endTime:String,
    requestDate:String,
    fullname:String,
    persianDate:String,
    status:number,
    flowchart:FlowchartPaper_Interface
}

export function Empty_PersoneOffTime_Interface():PersoneOffTime_Interface{
    return{
      id:0,
      dsc:'',
      startTime:'',
      endTime:'',
      requestDate:'',
      fullname:'',
      persianDate:'',
      status:0,
      flowchart:Empty_FlowchartPaper_Interface()
    }
  }